import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ArtificialIntelligenceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ArtificialIntelligence",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m16.97 2.58 2.66 4.86c1.14 2.09 2.86 3.8 4.94 4.94l4.86 2.66c.77.42.77 1.53 0 1.94l-4.85 2.66c-2.09 1.14-3.8 2.86-4.94 4.94l-2.66 4.85c-.42.77-1.53.77-1.94 0l-2.66-4.86c-1.14-2.09-2.86-3.8-4.94-4.94l-4.86-2.66c-.77-.42-.77-1.53 0-1.94l4.86-2.66c2.09-1.14 3.8-2.86 4.94-4.94l2.64-4.85c.42-.77 1.53-.77 1.94 0Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29 17c-7.72 0-14-6.28-14-14 0-.55.45-1 1-1s1 .45 1 1c0 6.62 5.38 12 12 12 .55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 30c-.55 0-1-.45-1-1 0-7.72 6.28-14 14-14 .55 0 1 .45 1 1s-.45 1-1 1c-6.62 0-12 5.38-12 12 0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 30c-.55 0-1-.45-1-1 0-6.62-5.38-12-12-12-.55 0-1-.45-1-1s.45-1 1-1c7.72 0 14 6.28 14 14 0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 17c-.55 0-1-.45-1-1s.45-1 1-1c3.8 0 7.3-1.75 9.59-4.79.33-.44.96-.53 1.4-.2s.53.96.2 1.4C11.52 14.96 7.44 16.99 3 16.99Z"
      })]
    })
  }));
};